import React, { useEffect, useRef } from 'react';
import { Redirect } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import Loading from 'components/Loading';
import useLogged from 'hooks/useLogged';

// Public entry point for marketing campaigns: starts a fresh Keycloak
// registration (new state/nonce) on every visit. UTM parameters are captured
// in index.tsx before the first render.
const Cadastro = () => {
    const { keycloak } = useKeycloak();
    const { register } = useLogged();
    const registerStarted = useRef<boolean>(false);

    useEffect(() => {
        if (keycloak.authenticated) return;

        // Deferred so it runs after the Routes.tsx effect, which clears the
        // localStorage (where keycloak-js keeps the callback state) for
        // unauthenticated users. The guard lives in the callback so a
        // StrictMode re-run of the effect does not trigger a second redirect.
        setTimeout(() => {
            if (registerStarted.current) return;
            registerStarted.current = true;
            register('/');
        }, 0);
    }, []);

    if (keycloak.authenticated) {
        return <Redirect to="/" />;
    }

    return <Loading />;
};

export default Cadastro;
